enum MaterialPriceIndicatorId {
    Cheap = 'cheap',
    Regular = 'regular',
    Expensive = 'expensive',
    VeryExpensive = 'veryExpensive',
}

export default MaterialPriceIndicatorId;
